package com.klantenstop.web.data.models.domain

import com.klantenstop.web.data.models.dto.responses.CategoryDto
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant

data class Category(
    val id: String,
    val slug: String,
    val name: String,
    val altText: String?,
    val highlighted: Boolean,
    val description: String,
    val logo: MediaFile?,
    val createdAt: Instant,
    val updatedAt: Instant
) {
    val publicIdentifier: String get() = slug.ifEmpty { id }

    fun matchesIdentifier(identifier: String?): Boolean =
        identifier != null && (identifier == id || identifier == slug)
}

fun CategoryDto.toCategory() = Category(
    id = id,
    slug = slug,
    name = name,
    altText = altText,
    highlighted = highlighted,
    description = description,
    logo = logo?.toMediaFile(),
    createdAt = LocalDateTime.parse(createdAt).toInstant(TimeZone.UTC),
    updatedAt = LocalDateTime.parse(updatedAt).toInstant(TimeZone.UTC)
)
